define(['moduler'], function (Moduler) {
    'use strict';

    return Moduler.create({
        init: function () {
            var self = this;
            var formFields = '.FloatedLabel input, .FloatedLabel textarea, .FloatedLabel select';

            var eventHandler = function (e) {
                let t = e.target.classList.contains('.FloatedLabel') ? e.target : e.target.closest('.FloatedLabel');
                if (t) {
                    if (e.type === 'refreshLabel') {
                        if (e.currentTarget.value !== '') {
                            t.classList.add("is-active");
                        }
                    } else {
                        t.classList.add("is-active");
                    }
                }
            }

            var refreshEvent = new Event('refreshLabel');

            self.el.querySelectorAll(formFields).forEach(el => {
                el.addEventListener('focus', eventHandler);
                el.addEventListener('keyup', eventHandler);
                el.addEventListener('refreshLabel', eventHandler);
                el.addEventListener('input', eventHandler);

                el.addEventListener('blur', function (e) {
                    var label = e.target.closest('.FloatedLabel');
                    if ((e.target.value === '' || e.target.value === 'blank') && !label.classList.contains('.FloatedLabel--fixed')) {
                        label.classList.remove('is-active');
                    }
                });

                el.dispatchEvent(refreshEvent);
            });

            self.el.querySelectorAll('.FloatedLabel-label').forEach(el => {
                el.addEventListener('click', function (e) {
                    var t = e.target.closest('.FloatedLabel');
                    if (t) {
                        t.querySelectorAll(':input').forEach(el => el.focus());
                    }
                });
            });
        }
    });
});